/* eslint-disable */
export default {
  flipHeader: 'Commuta chiamata su...',
  flip: 'Commuta',
  complete: 'Completa commutazione',
} as const;

// @key: @#@"flipHeader"@#@ @source: @#@"Flip Call to..."@#@
// @key: @#@"flip"@#@ @source: @#@"Flip"@#@
// @key: @#@"complete"@#@ @source: @#@"Complete Flip"@#@
